module.exports = __webpack_public_path__ + "img/Pro-12.d6a60ee9.jpg";